module.exports = __webpack_public_path__ + "img/arrow-circle-yellow.6bc5cf94.svg";